<div class="app-content">
  <router-outlet />
</div>
<app-loading-overlay />
<app-notification-center />
<app-connection-status />
